/**
 * 是否是参数类型
 *
 * @param {Object} value 测试的值
 * @return {Boolean}
 */
import isType from './is-type';

const isError = function(value: any): value is Error {
  return isType(value, 'Error');
};

export default isError;
